// Route paths
export const ROUTES = {
  ROOT: '/',
  SIGN_IN: '/signin',
  SIGNED_IN: '/signedin',
  ONBOARDING: '/onboarding',
  DASHBOARD: '/dashboard',
  COLLABORATION: '/collaboration',
  // Game routes
  GAME_CENTER: '/game-center',
  PLAY_GAME_WITHOUT_INTRODUCTION: '/playgame-without-introduction',
  PLAY_GAME_WITH_INTRODUCTION: '/playgame-with-introduction'
} as const

// Navigation helper
export const navigateTo = (path: string) => {
  window.history.pushState({}, '', path)
  // Dispatch a custom event to notify components of route change
  window.dispatchEvent(new PopStateEvent('popstate'))
}

// Get current route
export const getCurrentRoute = (): string => {
  return window.location.pathname
}

type RoutingUser = {
  hasCompletedOnboarding?: boolean
  lastSessionId?: string | null
}

// Check if user should be redirected
export const shouldRedirectToOnboarding = (user: RoutingUser | null | undefined): boolean => {
  if (!user) return true
  return !user.hasCompletedOnboarding
}

// Check if user should be redirected to dashboard
export const shouldRedirectToDashboard = (user: RoutingUser | null | undefined): boolean => {
  if (!user) return false
  return user.hasCompletedOnboarding === true && !user.lastSessionId
}

// Check if user should be redirected to collaboration
export const shouldRedirectToCollaboration = (user: RoutingUser | null | undefined): boolean => {
  if (!user) return false
  return user.hasCompletedOnboarding === true && !!user.lastSessionId
}
